"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactMarkdown = _interopRequireDefault(require("react-markdown"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _componentsWeb = require("@telus-uds/components-web");
var _alloyAnalytics = _interopRequireDefault(require("@telus/alloy-analytics/lib/alloyAnalytics"));
var _staticContent = require("../staticContent");
var _constants = require("../constants");
var _utils = require("../utils");
var _useStepTrackerContext = _interopRequireDefault(require("../hooks/useStepTrackerContext"));
var _templateObject;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
var topSpacingValue = 5;
var bottomSpacingValue = 4;
var MarkDownCheckRegex = /\[[^.*]+\]\(https:\/\/\S+\)/;
var StyledBackground = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  word-break: break-word;\n  }\n"])));
var ConsentField = props => {
  var {
    onChange = () => {},
    legalTemplate = '',
    options = [],
    errorMessage = '',
    clickedSubmit = false,
    language = _constants.CONTENTFUL_LOCALE.en,
    inputRef = /*#__PURE__*/_react.default.createRef(),
    isReadOnly = false
  } = props;
  var [itemsChecked, setItemsChecked] = (0, _react.useState)(new Set());
  var [hasInteracted, setHasInteracted] = (0, _react.useState)(false);
  var [userGaveConsentLEGACY, setUerGaveConsentLEGACY] = (0, _react.useState)(isReadOnly || false);
  var [showErrorMessage, setShowErrorMessage] = (0, _react.useState)(false);
  var {
    buttonControlPressed,
    currentStepReferences
  } = (0, _useStepTrackerContext.default)();
  var validate = (0, _react.useCallback)(() => {
    // Assume the field is valid, until proven otherwise
    var isValid = true;
    if (legalTemplate) {
      if (legalTemplate === 'Template B (SHS)') {
        isValid = true;
      } else {
        isValid = isReadOnly || userGaveConsentLEGACY;
      }
    } else {
      // Need to ensure all options that have checkboxes are checked
      var numOfCheckboxes = 0;
      options.forEach(option => {
        if (option.label && option.value) {
          numOfCheckboxes += 1;
        }
      });
      // If there are no checkboxes to render (i.e: only disclaimers displayed), the form
      // is technically valid, otherwise, ensure the number of checkboxes match the
      // total of boxes checked
      if (numOfCheckboxes === 0) {
        // Here we need to notify the parent component via onChange to validate the entire form
        onChange(true, true);
        return true;
      }
      isValid = isReadOnly || hasInteracted && itemsChecked.size === numOfCheckboxes;
    }
    return isValid;
  }, [hasInteracted, itemsChecked.size, legalTemplate, onChange, options, userGaveConsentLEGACY, isReadOnly]);
  var errMsg = errorMessage || _staticContent.CONSENT_FIELD.ERROR_MESSAGE[language];
  var hasOptions = Array.isArray(options) && options.length > 0;
  // const hasOptions = options instanceof Array && options.length > 0

  var onFieldChange = (checkedVal, optionId) => {
    if (legalTemplate) {
      setUerGaveConsentLEGACY(!userGaveConsentLEGACY);
      setHasInteracted(true);
    } else {
      if (checkedVal) {
        setItemsChecked(prev => new Set(prev.add(optionId)));
      } else {
        // Delete itemChecked from Set
        setItemsChecked(prev => new Set([...prev].filter(itemChecked => itemChecked !== optionId)));
      }
      setHasInteracted(true);
    }
  };
  (0, _react.useEffect)(() => {
    if (clickedSubmit) {
      setShowErrorMessage(!validate());
    }
  }, [clickedSubmit, validate]);
  (0, _react.useEffect)(() => {
    if (buttonControlPressed) {
      if ((0, _utils.isStepInput)(inputRef, currentStepReferences)) {
        setShowErrorMessage(!validate());
      }
    }
  }, [buttonControlPressed, inputRef, currentStepReferences, validate]);
  (0, _react.useEffect)(() => {
    // Validate form if legal template is Template B (SHS) or if there are no options
    if (legalTemplate === 'Template B (SHS)' || options.length === 0 && !legalTemplate || options.length && !legalTemplate && options.every(option => !option.label && !option.value && option.disclaimer)) {
      setHasInteracted(true);
    }
  }, [legalTemplate, options]);
  (0, _react.useEffect)(() => {
    if (hasInteracted) {
      var isValid = validate();
      onChange(isValid, isValid);
    }
  }, [hasInteracted, itemsChecked, onChange, validate]);
  (0, _react.useEffect)(() => {
    if (showErrorMessage) {
      _alloyAnalytics.default.event('errorEvent').webInteraction({
        errorType: 'required_field_is_empty',
        errorDetails: _constants.FIELD_FEEDBACK.ERROR,
        errorMessage: errMsg
      }).fire();
    }
  }, [showErrorMessage, errMsg]);
  (0, _react.useEffect)(() => {
    onChange(isReadOnly, isReadOnly);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return legalTemplate === 'Template A' ? /*#__PURE__*/_react.default.createElement(_componentsWeb.Box, {
    top: topSpacingValue,
    bottom: bottomSpacingValue
  }, /*#__PURE__*/_react.default.createElement(StyledBackground, null, /*#__PURE__*/_react.default.createElement(_componentsWeb.Checkbox, {
    ref: inputRef,
    label: _staticContent.CONSENT_FIELD.CHECKBOX_LABEL[language],
    name: "consent",
    value: "true",
    error: showErrorMessage ? true : false,
    checked: isReadOnly || userGaveConsentLEGACY,
    onChange: value => onFieldChange(value, 1),
    inactive: isReadOnly
  }), _staticContent.CONSENT_FIELD.LEGAL_STATEMENT[language], showErrorMessage &&
  /*#__PURE__*/
  // The reason we are using an <InputFeedback> component instead of relying on 'error'
  // prop in <Checkbox> is that the 'error' from <Checkbox> will be individually placed
  // above each <Checkbox> option, where as we want to do validation on the whole
  // checkbox group. Therefore an <InputFeedback> here would fit our needs more.
  _react.default.createElement(_componentsWeb.Feedback, {
    title: errMsg,
    validation: _constants.FIELD_FEEDBACK.ERROR,
    variant: {
      icon: true
    }
  }))) : legalTemplate === 'Template B (SHS)' ? /*#__PURE__*/_react.default.createElement(_componentsWeb.Box, {
    top: topSpacingValue,
    bottom: bottomSpacingValue
  }, /*#__PURE__*/_react.default.createElement(StyledBackground, null, _staticContent.CONSENT_FIELD.LEGAL_SHS[language])) : /*#__PURE__*/_react.default.createElement(_componentsWeb.Box, {
    top: topSpacingValue,
    bottom: bottomSpacingValue
  }, /*#__PURE__*/_react.default.createElement(StyledBackground, null, hasOptions && options.map((option, index) => {
    var isMarkDown = MarkDownCheckRegex.test(option.disclaimer);
    return /*#__PURE__*/_react.default.createElement(_componentsWeb.Box, {
      vertical: 2,
      key: "consent-option_".concat(option.id)
    }, option.label && option.value && /*#__PURE__*/_react.default.createElement(_componentsWeb.Checkbox, {
      testID: "consent-checkbox-".concat(option.id),
      ref: index === 0 ? inputRef : /*#__PURE__*/_react.default.createRef(),
      label: option.label,
      id: option.id,
      name: _constants.FIELD_TYPES.CONSENT_FIELD,
      value: option.value,
      checked: isReadOnly || itemsChecked.has(option.id),
      error: showErrorMessage ? true : false,
      onChange: value => onFieldChange(value, option.id),
      inactive: isReadOnly
    }), option.disclaimer && !isMarkDown && /*#__PURE__*/_react.default.createElement(_componentsWeb.Disclaimer, {
      "data-testid": "disclaimer-".concat(option.id)
    }, option.disclaimer), option.disclaimer && isMarkDown && /*#__PURE__*/_react.default.createElement("div", {
      "data-testid": "disclaimer-markdown-".concat(option.id)
    }, /*#__PURE__*/_react.default.createElement(_reactMarkdown.default, {
      children: option.disclaimer,
      components: {
        a: props => props.href && props.href.includes('https') && /*#__PURE__*/_react.default.createElement(_componentsWeb.Link, {
          href: props.href,
          variant: {
            size: 'medium'
          },
          target: "_blank"
        }, props.children),
        p: props => /*#__PURE__*/_react.default.createElement(_componentsWeb.Typography, {
          variant: {
            size: 'medium'
          }
        }, props.children)
      }
    })));
  }), showErrorMessage &&
  /*#__PURE__*/
  // The reason we are using an <InputFeedback> component instead of relying on 'error'
  // prop in <Checkbox> is that the 'error' from <Checkbox> will be individually placed
  // above each <Checkbox> option, where as we want to do validation on the whole
  // checkbox group. Therefore an <InputFeedback> here would fit our needs more.
  _react.default.createElement(_componentsWeb.Feedback, {
    title: errMsg,
    validation: _constants.FIELD_FEEDBACK.ERROR,
    variant: {
      icon: true
    }
  })));
};
ConsentField.propTypes = {
  legalTemplate: _propTypes.default.string,
  errorMessage: _propTypes.default.string,
  onChange: _propTypes.default.func,
  options: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string,
    value: _propTypes.default.string,
    id: _propTypes.default.string,
    disclaimer: _propTypes.default.string
  }).isRequired),
  language: _propTypes.default.string,
  clickedSubmit: _propTypes.default.bool,
  inputRef: _propTypes.default.object,
  isReadOnly: _propTypes.default.bool
};
var _default = exports.default = ConsentField;